import { PageTitle } from '@/shared/ui/text/page-title';
import { SettingsColumn } from '@/widgets/settings/settings-column';

import { BillingAutomationSection } from './billing-settings-page/billing-automation-section';
import { FeesSection } from './billing-settings-page/fees-section';

export function BillingSettingsPage() {
    return (
        <SettingsColumn className="space-y-8">
            <PageTitle>Billing settings</PageTitle>
            <FeesSection />
            <BillingAutomationSection />
        </SettingsColumn>
    );
}
